<template>
  <van-popup
    position="bottom"
    :value="isPopup"
    @click-overlay="$emit('close')"
    @close="closePopup()"
    :style="{ height: popupHeight }"
  >
    <van-picker
      v-if="type === 'picker'"
      show-toolbar
      :title="title"
      :columns="timeColumns"
      @cancel="$emit('close')"
      @confirm="setPickerArr"
      :style="{ height: 'calc(' + popupHeight + ' - 87px)' }"
    />

    <van-calendar
      ref="calendar"
      color="#36b374"
      v-if="type === 'calendar'"
      type="range"
      :title="title"
      :poppable="false"
      :show-confirm="false"
      :min-date="new Date(2018, 1, 1)"
      :allowSameDay="allowSameDay"
      v-swipeup="{ fn: swipeup, name: '上滑' }"
    >
      <div class="title-box" slot="title">
        <div class="close" @click="$emit('close')">取消</div>
        <div class="title one-txt-cut">{{ title }}</div>
        <div class="confirm" @click="calendarConfirm">确定</div>
      </div>
    </van-calendar>

    <div class="switch-box">
      <div class="switch" v-if="type === 'picker'" @click="toggle('calendar')">
        自定义日期
      </div>
      <!-- <div class="switch" v-if="type === 'calendar'" @click="toggle('picker')">
        自定义日期
      </div> -->
    </div>
  </van-popup>
</template>

<script>
/**
 * 使用方式，实现双向绑定 v-model，返回为数组对象，包含起始时间和结束时间
 * 需传入 isPopup 用于弹窗展示
 * @close 关闭弹窗
 * @confirm 确定时返回 label 选中标签， timeArr [startDate, endDate]
 */
import moment from "moment";
// 弹窗管理总栈

export default {
  name: "PopupBus",
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "时间",
    },
    allowSameDay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeColumns: [
        {
          text: "全部年份",
          value: "",
          children: [
            {
              text: "- -",
              children: [
                {
                  text: "- -",
                  value: ["", ""],
                },
              ],
            },
          ],
        },
      ],
      type: "picker", // 'picker' 标准时段; 'calendar' 自定义时间
      popupHeight: "332px",
    };
  },
  created() {
    this.initTime();
  },
  methods: {
    initTime() {
      const timeColumns = this._.cloneDeep(this.timeColumns);
      let year = new Date().getFullYear() + 1

      while (--year >= 2018) {
        const timeItem = {
          text: year + "年",
          value: year + "/",
          children: [
            {
              text: "全年",
              children: [
                {
                  text: "- -",
                  value: ["01/01", "12/31"],
                },
              ],
            },
            {
              text: "季度",
              children: this.getQuarter(),
            },
            {
              text: "月份",
              children: this.getMonth(year),
            },
          ],
        };
        timeColumns.push(timeItem);
      }

      this.$set(this, "timeColumns", timeColumns);
    },
    closePopup() {
      this.toggle('picker')
      this.$emit('close')
    },
    getQuarter() {
      return [
        { text: "第一季度", value: ["01/01", "03/31"] },
        { text: "第二季度", value: ["04/01", "06/30"] },
        { text: "第三季度", value: ["07/01", "09/30"] },
        { text: "第四季度", value: ["10/01", "12/31"] },
      ];
    },
    getMonth(year) {
      const monthList = [];
      const dayList = [
        31,
        moment([year]).isLeapYear() ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];
      for (let i = 0; i < 12; i++) {
        monthList.push({
          text: i + 1 + "月",
          value: [i + 1 + "/01", i + 1 + "/" + dayList[i]],
        });
      }
      return monthList;
    },
    setPickerArr(textArr, indexArr) {
      // console.log("setPickerArr", textArr, indexArr);

      let label = "";

      for (let i = 0; i < textArr.length; i++) {
        const text = textArr[i];
        label += i !== 1 && text !== "- -" ? textArr[i] : "";
      }

      const yearIndex = indexArr[0];
      const yearItem = this.timeColumns[yearIndex];
      const monthIndex = indexArr[1];
      const monthItem = yearItem.children[monthIndex];
      const dayIndex = indexArr[2];
      const dayItem = monthItem.children[dayIndex];
      const timeArr = [
        yearItem.value + (dayItem.value && dayItem.value[0]),
        yearItem.value + (dayItem.value && dayItem.value[1]),
      ];

      // console.log(yearItem.value, timeArr);
      this.$emit("input", timeArr);
      this.$emit("confirm", label, timeArr);
      this.$emit("close");

      return [label, timeArr];
    },
    calendarConfirm() {
      console.log(this.$refs.calendar);
      const dateArr = this.$refs.calendar.currentDate;
      if (!dateArr[1]) {
        dateArr[1] = dateArr[0];
      }
      const startDate = moment(dateArr[0]).format("YYYY/MM/DD");
      const endDate = moment(dateArr[1]).format("YYYY/MM/DD");

      let label = startDate + "~" + endDate;
      if (startDate == endDate) {
        label = startDate;
      }

      this.$emit("input", [startDate, endDate]);
      this.$emit("confirm", label, [startDate, endDate]);
      this.$emit("close");

      return [startDate + "~" + endDate, [startDate, endDate]];
    },
    swipeup(s, e) {
      // console.log(s, e);
      this.popupHeight = "100%";
    },
    toggle(type) {
      this.type = type;
      switch (type) {
        case "calendar":
          this.popupHeight = "50%";
          break;
        case "picker":
          this.popupHeight = "332px";
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-popup {
  border-radius: 4px 4px 0px 0px;
  transition: 0.5s all;
}
.switch-box {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
  width: 128px;
  z-index: 1;

  .switch {
    height: 32px;
    border: 1px solid #36b374;
    border-radius: 2px;
    filter: blur(10);

    font-family: PingFangSC-Regular;
    font-weight: Regular;
    font-size: 14px;
    color: #36b374;
    text-align: center;
    line-height: 32px;
  }
}
/deep/ .van-picker__cancel {
  padding: 0 16px;
  cursor: pointer;

  font-family: PingFangSC-Regular;
  font-weight: Regular;
  font-size: 16px !important;
  color: #9da0a4 !important;
  letter-spacing: 0;
  filter: blur(10);
}
/deep/ .van-picker__title {
  max-width: 50%;
  margin: 0 auto;
  text-align: center;

  font-family: PingFangSC-Medium;
  font-weight: 600;
  font-size: 16px !important;
  color: #171a1d !important;
  letter-spacing: 0;
  filter: blur(10);
}
/deep/ .van-picker__confirm {
  padding: 0 16px;
  cursor: pointer;

  font-family: PingFangSC-Medium;
  font-weight: Medium;
  font-size: 16px !important;
  color: #36b374 !important;
  letter-spacing: 0;
  filter: blur(10);
}
/deep/.van-picker-column__item--selected {
  font-weight: 600 !important;
}
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 44px;
  line-height: 44px;

  .close {
    padding: 0 16px;
    cursor: pointer;

    font-family: PingFangSC-Regular;
    font-weight: Regular;
    font-size: 16px;
    color: #9da0a4;
    letter-spacing: 0;
    filter: blur(10);
  }

  .title {
    max-width: 50%;
    margin: 0 auto;
    text-align: center;

    font-family: PingFangSC-Medium;
    font-weight: Medium;
    font-size: 16px;
    color: #171a1d;
    letter-spacing: 0;
    filter: blur(10);
  }

  .confirm {
    padding: 0 16px;
    cursor: pointer;

    font-family: PingFangSC-Medium;
    font-weight: Medium;
    font-size: 16px;
    color: #36b374;
    letter-spacing: 0;
    filter: blur(10);
  }
}
</style>
